import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PageHeader() {
  return <section id="page-header" className="relative w-full min-h-[45vh] flex items-center bg-gradient-to-b from-[#0F1B2D] to-secondary overflow-hidden py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="flex flex-col items-start">
            <Breadcrumb className="mb-6">
              <BreadcrumbList className="text-white/70 sm:gap-2">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="hover:text-white transition-colors">
                    <Link to="/">Home</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="text-white/50" />
                <BreadcrumbItem>
                  <BreadcrumbLink asChild className="hover:text-white transition-colors">
                    <Link to="#">Industries</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="text-white/50" />
                <BreadcrumbItem>
                  <BreadcrumbPage className="text-primary font-medium">Manufacturing</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>

            <span className="text-primary font-semibold tracking-wider uppercase text-sm mb-4 block">
              For Manufacturing
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-white mb-6 leading-tight">
              Manufacturing Plant Labeling — Equipment, Safety & Asset Tracking
            </h1>

            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl leading-relaxed font-sans">
              Evermark Industrial Solutions produces the identification a manufacturing plant runs on — engraved equipment nameplates, safety labels, panel marking, and serialized asset tags — durable, consistent, and from one source. Label the whole floor and track every asset to your scheme.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto text-base shadow-lg">
                <Link to="/ContactPage">Request a Quote</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base border-primary text-primary hover:bg-primary hover:text-primary-foreground bg-transparent shadow-lg">
                
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full aspect-video lg:aspect-square max-h-[500px] rounded-lg overflow-hidden shadow-2xl border border-white/10">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/manufacturing_plant_floor_labels.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/manufacturing_plant_floor_labels.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/manufacturing_plant_floor_labels.png-wvc-sizes" alt="Manufacturing plant labeling — equipment nameplates and asset tags by Evermark Industrial Solutions" className="w-full h-full object-cover" loading="eager" decoding="async" />
            {}
            <div className="absolute inset-0 bg-gradient-to-tr from-[#0F1B2D]/40 to-transparent pointer-events-none"></div>
          </div>

        </div>
      </div>
    </section>;
}